export const PERMITION_SETTINGS = 'main.Settings';
export const PERMITION_NOTIFICATIONS = 'main.Notifications';
export const PERMITION_USERS = 'Settings.Users';
export const PERMITION_USERS_READ = 'Users.Read';
export const PERMITION_USERS_CREATE = 'Users.Create';
export const PERMITION_USERS_UPDATE = 'Users.Update';
export const PERMITION_USERS_DELETE = 'Users.Delete';
export const PERMITION_USERS_EXPORT = "Users.Export";
export const PERMITION_PROFILE = 'Settings.Profile';
export const PERMITION_PROFILE_READ = 'Profile.Read';
export const PERMITION_PROFILE_CREATE = 'Profile.Create';
export const PERMITION_PROFILE_UPDATE = 'Profile.Update';
export const PERMITION_PROFILE_DELETE = 'Profile.Delete';
export const PERMITION_MESSAGES = 'Settings.Messages';
export const PERMITION_MESSAGES_READ = 'Messages.Read';
export const PERMITION_MESSAGES_CREATE = 'Messages.Create';
export const PERMITION_MESSAGES_UPDATE = 'Messages.Update';
export const PERMITION_MESSAGES_DELETE = 'Messages.Delete';
export const PERMITION_BANNERS = 'Settings.Banners';
export const PERMITION_BANNERS_READ = 'Banners.Read';
export const PERMITION_BANNERS_CREATE = 'Banners.Create';
export const PERMITION_BANNERS_UPDATE = 'Banners.Update';
export const PERMITION_BANNERS_DELETE = 'Banners.Delete';
export const PERMITION_CONSUMPTION_REPORT = 'Settings.ConsumptionReport';
export const PERMITION_CONSUMPTION_REPORT_READ = 'ConsumptionReport.Read';
export const PERMITION_CONSUMPTION_REPORT_EXPORT_XLS = 'ConsumptionReport.Export';
export const PERMITION_SETTINGS_PARAMETER = 'Settings.Parameters';
export const PERMITION_SETTINGS_PARAMETER_READ = 'Parameters.Read';
export const PERMITION_SETTINGS_PARAMETER_UPDATE = 'Parameters.Update';
export const PERMITION_SETTINGS_AWARD_PROGRAM = 'Settings.AwardProgram';
export const PERMITION_SETTINGS_AWARD_PROGRAM_READ = 'AwardProgram.Read';
export const PERMITION_SETTINGS_AWARD_PROGRAM_UPDATE = 'AwardProgram.Update';
export const PERMITION_SETTINGS_AWARD_PROGRAM_CREATE = 'AwardProgram.Create';
export const PERMITION_SETTINGS_AWARD_PROGRAM_DELETE = 'AwardProgram.Delete';
export const PERMITION_SETTINGS_AWARD_PROGRAM_IMPORTHISTORY = 'AwardProgram.ImportHistory';
export const PERMITION_SETTINGS_AWARD_PROGRAM_IMPORTCRITERIA = 'AwardProgram.ImportCriteria';
export const PERMITION_SETTINGS_AWARD_PROGRAM_IMPORTCURRENT = 'AwardProgram.ImportCurrent';
export const PERMITION_SETTINGS_AWARD_PROGRAM_LOGSIMPORT = 'AwardProgram.LogsImport';

export const PERMITION_DEALERS = "Bad debt";
export const PERMITION_DEALERS_DEBTORS = "Bad debt.Consult debtors";
export const PERMITION_DEALERS_HISTORY = "Bad debt.Debt treatment history";
export const PERMITION_DEALERS_SETTLEMENT = "Bad debt.Treat with debtor";
export const PERMITION_DEALERS_DEBTORS_READ = "Bad debt.Read";

export const PERMITION_DEALERS_READ = "Dealers.Read";

export const PERMITION_SETTINGS_DEALERS = "Settings.Dealers";
export const PERMITION_SETTINGS_DEALERS_CREATE = "Dealers.Create";
export const PERMITION_SETTINGS_DEALERS_UPDATE = "Dealers.Update";
export const PERMITION_SETTINGS_DEALERS_DELETE = "Dealers.Delete";
export const PERMITION_SETTINGS_DEALERS_READ = "Dealers.Read";


export const PERMITION_ECONOMICGROUPS = "Settings.EconomicGroup";
export const PERMITION_ECONOMICGROUPS_READ = "EconomicGroup.Read";
export const PERMITION_ECONOMICGROUPS_CREATE = "EconomicGroup.Create";
export const PERMITION_ECONOMICGROUPS_UPDATE = "EconomicGroup.Update";
export const PERMITION_ECONOMICGROUPS_DELETE = "EconomicGroup.Delete";

export const PERMITION_REPORTS = "main.Reports";
export const PERMITION_REPORTS_BIRTHDATE = "Reports.BirthDate";

export const PERMITION_CONSORTIUM = "main.Consortium";
export const PERMITION_CONSORTIUM_SALES = "Consortium.Sales";
export const PERMITION_CONSORTIUM_SALES_SALESTABLE = "Sales.SalesTable";
export const PERMITION_CONSORTIUM_SALES_SALESTABLE_READ = "SalesTable.Read";
export const PERMITION_CONSORTIUM_SALES_SALESTABLE_CREATE = "SalesTable.Create";
export const PERMITION_CONSORTIUM_SALES_SALESTABLE_DELETE = "SalesTable.Delete";

export const PERMITION_CONSORTIUM_SALES_PANEL = "Sales.SalesPainel";
export const PERMITION_CONSORTIUM_SALES_PANEL_READ = "SalesPainel.Read";
export const PERMITION_CONSORTIUM_SALES_PANEL_READ_DETAILS = "SalesPainel.View Details";
export const PERMITION_CONSORTIUM_SALES_PANEL_EXPORT_XLSX = "SalesPainel.Export XLSX";
export const PERMITION_CONSORTIUM_SALES_PANEL_EXPORT_PDF = "SalesPainel.Export PDF";

export const PERMITION_CONSORTIUM_REPORTS = "Consortium.Reports";

export const PERMITION_CONSORTIUM_REPORTS_COMMISSIONS = "Reports.Commissions";
export const PERMITION_CONSORTIUM_REPORTS_COMISSIONS_READ = "Commissions.Read";
export const PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_EXPORT_PDF = "Commissions.Export PDF";
export const PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_EXPORT_XLSX = "Commissions.Export XLSX";

export const PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_READ = "Commissions.View Details";
export const PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_EXPORT_PDF = "Commissions.Export Details PDF";
export const PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_EXPORT_XLSX = "Commissions.Export Details XLSX";


export const PERMITION_CONSORTIUM_RELATIONSHIP_PANEL = "Consortium.Relationship Portal";
export const PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM = "Relationship Portal.Read Criteria Consortium";
export const PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM_EXPORT_PDF = "Relationship Portal.Export PDF Consortium";
export const PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM_EXPORT_XLSX = "Relationship Portal.Export XLSX Consortium";



export const PERMITION_CONSORTIUM_REPORTS_BIRTHDATE = "Reports.BirthDate";
export const PERMITION_CONSORTIUM_REPORTS_BIRTHDATE_VIEWDETAILS = "BirthDate.View Details";
export const PERMITION_CONSORTIUM_REPORTS_BIRTHDATE_EXPORT_PDF = "BirthDate.Export PDF";
export const PERMITION_CONSORTIUM_REPORTS_BIRTHDATE_EXPORT_XLSX = "BirthDate.Export XLSX";
export const PERMITION_CONSORTIUM_REPORTS_BIRTHDATE_READ = "BirthDate.Read";

export const PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT = "Reports.Portfolio Management";
export const PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT_READ = "Portfolio Management.Read";
export const PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT_READ_DETAILS = "Portfolio Management.View Details";
export const PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT_EXPORT_PDF = "Portfolio Management.Export PDF";
export const PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT_EXPORT_EXCEL = "Portfolio Management.Export XLSX";

export const PERMITION_CONSORTIUM_CREDIT_ANALISYS = "Consortium.Credit Analysis";
export const PERMITION_CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT = "Credit Analysis.Contemplation Payment";
export const PERMITION_CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT_READ = "Contemplation Payment.Read";
export const PERMITION_CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT_EXPORT_PDF = "Contemplation Payment.Export PDF";
export const PERMITION_CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT_EXPORT_XLSX = "Contemplation Payment.Export XLSX";

export const PERMITION_CONSORTIUM_PORTAL_CONSORTIUM = "Consortium.Portal Consortium";


export const PERMITION_BANK = "main.Bank";

export const PERMITION_BANK_RELATIONSHIP_PANEL = "Bank.Relationship Portal";
export const PERMITION_BANK_READ_CRITERIA_BANK = "Relationship Portal.Read Criteria Bank";
export const PERMITION_BANK_READ_CRITERIA_BANK_BANK_EXPORT_PDF = "Relationship Portal.Export PDF Bank";
export const PERMITION_BANK_READ_CRITERIA_BANK_EXPORT_XLSX = "Relationship Portal.Export XLSX Bank";
export const PERMITION_BANK_READ_CRITERIA_BANK_EXPORT_PDF = "Relationship Portal.Export PDF Bank";

export const PERMITION_INSURANCE = "main.Insurance";

export const PERMITION_INSURANCE_RELATIONSHIP_PANEL = "Insurance.Relationship Portal";
export const PERMITION_INSURANCE_READ_CRITERIA_INSURANCE = "Relationship Portal.Read Criteria Insurance";
export const PERMITION_INSURANCE_READ_CRITERIA_INSURANCE_EXPORT_PDF = "Relationship Portal.Export PDF Insurance";
export const PERMITION_INSURANCE_READ_CRITERIA_INSURANCE_EXPORT_XLSX = "Relationship Portal.Export XLSX Insurance";

export const PERMITION_BANK_BAD_DEBT = "Bank.Bad debt";
export const PERMITION_BANK_BAD_DEBT_READ = "Bad debt.Read";

export const PERMITION_REPORTS_RECEIVABLES_RECONCILIATION = "Reports.Receivables reconciliation";
export const PERMITION_REPORTS_RECEIVABLES_RECONCILIATION_READ = "Receivables reconciliation.Read";
export const PERMITION_REPORTS_RECEIVABLES_RECONCILIATION_READ_DETAILS = "Receivables reconciliation.View Details";
export const PERMITION_CONSORTIUM_REPORTS_RECEIVABLES_RECONCILIATION_EXPORT_XLSX = "Receivables reconciliation.Export XLSX";
export const PERMITION_CONSORTIUM_REPORTS_RECEIVABLES_RECONCILIATION_EXPORT_PDF = "Receivables reconciliation.Export PDF";
export const PERMITION_CONSORTIUM_REPORTS_RECEIVABLES_RECONCILIATION_EXPORT_DETAILS_XLSX = "Receivables reconciliation.Export Details XLSX";
export const PERMITION_CONSORTIUM_REPORTS_RECEIVABLES_RECONCILIATION_EXPORT_DETAILS_PDF = "Receivables reconciliation.Export Details PDF";
